module.exports = __webpack_public_path__ + "static/media/aboutPage_banner.746ab4bf.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/aboutPage_banner.jpg
// module id = 296
// module chunks = 0